import React from 'react';
import { Button, Modal, ModalFooter, ModalHeader, ModalBody } from "reactstrap";

interface Props {
    isOpen?: boolean;
    toggle?: any;
    headerText?: string;
    children?: any;
    footer?: any;
    okText?: string;
    cancelText?: string;
    size?: 'sm' | 'md' | 'lg' | 'xl';
    onOkClick?: () => any;
    onClose?: () => any;
}

const PrometModal = (props: Props) => {
    document.onkeydown = function (evt) {
        if (evt.key === 'Escape') {
            if (props.onClose) {
                props.onClose();
            }
        }
    };

    return (
        <Modal isOpen={props.isOpen} toggle={props.onClose} size={props.size || 'md'}>
            {
                props.headerText &&
                <ModalHeader toggle={props.toggle}>
                    {props.headerText}
                </ModalHeader>
            }
            {
                props.children &&
                <ModalBody>
                    {props.children}
                </ModalBody>
            }
            {
                props.footer &&
                <ModalFooter>
                    {
                        props.cancelText &&
                        <Button color="primary" outline toggle={props.toggle} onClick={props.onClose}>{props.cancelText}</Button>
                    }
                    <Button color="primary" toggle={props.toggle} onClick={props.onOkClick}>{props.okText}</Button>
                </ModalFooter>
            }
        </Modal>
    );
};

export default PrometModal;
